import { Button, Typography } from "antd";
import React, { useEffect, useState } from "react";
import FormSetup from "../../../../components/Forms/FormSetup";
import { FormColumnConfig, MasterConfigs } from "../../../../interfaces/entity";
import { constants } from "../../../../constants/common";
import { FormInstance } from "antd/lib";
const { Text } = Typography;

const LeaveSettup = ({ data }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [formInstance, setForm] = useState<FormInstance>(null);
    const [formValues, setFormValues] = useState(null);

    const payload = {
        leaves: data._id,
        singleRecord: true
    }

    const config: MasterConfigs = {
        modalTitle: () => 'Leave Setup',
        title: 'Leave Setup',
        // api: () => '/leave-settings',
        stepesProps: {
            size: 'small',
        },
        isSteps: true,
        handleValuesChange: (e, values) => {
            if (values.leaveRequestApproval === true) {
                formInstance?.setFieldsValue({ approvalForm: values.approvalForm ? values.approvalForm : [{ levelType: null, approval: null }] })
            }
            setFormValues(values)
        },
        getFormColumns: () => [
            {
                api: () => '/leave-yearly-quota',
                apiParams: payload,
                prepoluate: payload,
                tabName: 'Yearly Quota',
                getChiledForm: () => [
                    {
                        type: 'radio',
                        label: 'This leave is calculated in',
                        name: 'leaveCalculation',
                        rules: [{ required: true, message: 'Field is required' }],
                        children: [
                            { name: 'Days', value: 'Days' },
                            { name: 'Hours', value: 'Hours' },
                        ],
                        radioProps: { direction: 'horizontal' }
                    },
                    {
                        type: 'custom',
                        span: 16,
                    },
                    {
                        type: 'select',
                        label: 'Yearly Quota',
                        name: 'yearlyQuotaType',
                        rules: [{ required: true, message: 'Field is required' }],
                        children: [{ name: 'Days', value: 'Days' }, { name: 'Unlimited', value: 'Unlimited' }],
                    },
                    formValues && formValues?.yearlyQuotaType === 'Days' && {
                        type: 'number',
                        label: 'Days',
                        name: 'yearlyQuota',
                        rules: [{ required: true, message: 'Field is required' }],
                    }
                ].filter(Boolean) as FormColumnConfig[]
            },
            {
                api: () => '/leave-approvals',
                prepoluate: payload,
                tabName: 'Approval',
                getChiledForm: () => [
                    {
                        type: 'checkbox',
                        label: 'Leave request requires an approval',
                        name: 'leaveRequestApproval',
                    },
                    formValues && formValues?.leaveRequestApproval && {
                        type: 'form',
                        label: 'Approval Form',
                        name: 'approvalForm',
                        key: 'approvalForm',
                        span: 24,
                        form: [
                            {
                                type: 'select',
                                label: 'Level Type',
                                name: 'levelType',
                                span: 8,
                                rules: [{ required: true, message: 'Field is required' }],
                                children: [
                                    { name: 'Level 1', value: 1 },
                                    { name: 'Level 2', value: 2 },
                                    { name: 'Level 3', value: 3 },
                                    { name: 'Level 4', value: 4 },
                                    { name: 'Level 5', value: 5 },
                                ]
                            },
                            {
                                type: 'select',
                                label: 'Approval',
                                name: 'approval',
                                span: 8,
                                rules: [{ required: true, message: 'Field is required' }],
                                children: [
                                    { name: 'Manager', value: 'Manager' },
                                    { name: 'HR', value: 'HR' },
                                ]
                            }
                        ],
                    }
                ].filter(Boolean) as FormColumnConfig[]
            },
            {
                api: () => '/leave-probations',
                apiParams: payload,
                prepoluate: payload,
                tabName: 'Probation Period',
                getChiledForm: () => [
                    {
                        type: 'customCheckBox',
                        span: 24,
                        rowProps: { gutter: [16, 16] },
                        formItems: [
                            {
                                type: 'checkbox',
                                label: 'New joiners can request leave after',
                                name: 'canRequestLeave',
                            },
                            {
                                type: 'number',
                                name: 'days',
                                rules: [{ required: true, message: 'Field is required' }],
                                inputNumberProps: { disabled: !formValues?.canRequestLeave }
                            },
                            {
                                type: 'custom',
                                formItem: (e) => <Text>days of their</Text>
                            },
                            {
                                type: 'select',
                                name: 'period',
                                rules: [{ required: true, message: 'Field is required' }],
                                children: [
                                    constants.JOINING_DATE,
                                    constants.PROBATION_END
                                ],
                                selectProps: { disabled: !formValues?.canRequestLeave }
                            }
                        ]
                    },
                    {
                        type: 'customCheckBox',
                        span: 24,
                        rowProps: { gutter: [16, 16] },
                        formItems: [
                            {
                                type: 'checkbox',
                                label: 'Maximum',
                                name: 'maxLeaveInProbation',
                            },
                            {
                                type: 'number',
                                name: 'maxLeaveInProbationDays',
                                rules: [{ required: true, message: 'Field is required' }],
                                inputNumberProps: { disabled: !formValues?.maxLeaveInProbation }
                            },
                            {
                                type: 'custom',
                                formItem: (e) => <Text>days of leave can be taken during probation period</Text>
                            }
                        ]
                    },
                ]
            },
            {
                api: () => '/leave-in-bench',
                apiParams: payload,
                prepoluate: payload,
                tabName: 'Bench Period',
                getChiledForm: () => [
                    {
                        type: 'customCheckBox',
                        span: 24,
                        rowProps: { gutter: [16, 16] },
                        formItems: [
                            {
                                type: 'checkbox',
                                label: 'Maximum',
                                name: 'maxLeaveInBench',
                            },
                            {
                                type: 'number',
                                name: 'days',
                                rules: [{ required: true, message: 'Field is required' }],
                                inputNumberProps: { disabled: !formValues?.maxLeaveInBench }
                            },
                            {
                                type: 'custom',
                                formItem: (e) => <Text>days of leave can be taken during Bench period</Text>
                            }
                        ]
                    },

                ]
            },
            {
                api: () => '/leave-in-notice',
                apiParams: payload,
                prepoluate: payload,
                tabName: 'Notice Period',
                getChiledForm: () => [
                    {
                        type: 'customCheckBox',
                        span: 24,
                        rowProps: { gutter: [16, 16] },
                        formItems: [
                            {
                                type: 'checkbox',
                                label: 'Leave taken in notice period will extend it by',
                                name: 'maxLeaveInNotice',
                            },
                            {
                                type: 'number',
                                name: 'days',
                                rules: [{ required: true, message: 'Field is required' }],
                                inputNumberProps: { disabled: !formValues?.maxLeaveInNotice }
                            },
                            {
                                type: 'custom',
                                formItem: (e) => <Text>time(s) for each leave availed</Text>
                            }
                        ]
                    },
                ]
            }
        ],
    }

    return (
        <>
            <FormSetup config={config} onClose={() => setIsOpen(false)} open={isOpen} form={(e) => setForm(e)} />
            <Button type="link" danger onClick={() => setIsOpen(true)}>Setup</Button>
        </>
    )
}

export default LeaveSettup;